export { GoogleTagManager } from '@next/third-parties/google';
export { GoogleTagManagerNoScript } from './GoogleTagManagerNoScript';
export { gtmTrackEvent } from './gtmTrackEvent';
